var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"tripeditor","category-name":"TRiP EDiTOR賞","category-intro":"「旅も人生も、もっと楽しく編集できる」をテーマにしたWebメディア「TRiP EDiTOR」が厳選。読めばきっと旅に出かけたくなるメルマガをセレクトしました。"}})}
var staticRenderFns = []

export { render, staticRenderFns }